'use client'

// SP-webではcrypto.subtleが使えないため、js-sha256を使用
import { sha256 } from 'js-sha256'
import { useEffect, useState } from 'react'
import { getAnonymousUserId } from '~/libs/anonymousUserId'

/**
 * A/Bテスト用カスタムフック
 * - クエリパラメータにexperimentNameとexperimentFlagが両方セットされており、experimentNameが一致する場合は
 *   experimentFlagが"treatment"(実験群)ならtrue、"control"(対称群)ならfalseを返す（強制グループ指定）
 * - それ以外の場合は匿名ユーザーIDとexperimentNameのSHA-256ハッシュ値でグループを決定
 *   （最下位バイトが奇数ならtrue("treatment")、偶数ならfalse("control")）
 */
export const useExperiment = (experimentName: string): boolean | null => {
  const [isTreatment, setIsTreatment] = useState<boolean | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const experimentNameParams = params.get('experimentName')
    const experimentFlag = params.get('experimentFlag')

    if (
      experimentNameParams === experimentName &&
      (experimentFlag === 'treatment' || experimentFlag === 'control')
    ) {
      setIsTreatment(experimentFlag === 'treatment')
      return
    }

    const userId = getAnonymousUserId()
    const input = `${userId}${experimentName}`

    const hash = sha256(input)
    const lastByte = parseInt(hash.slice(-2), 16) // 末尾の整数を取得
    setIsTreatment(lastByte % 2 === 1)
  }, [experimentName])

  return isTreatment
}
